import { GlobalSearchTrigger } from "./GlobalSearch";
import { NewEntityButton } from "./NewEntityButton";
import { NotificationBell } from "@/components/flow/NotificationBell";
import { HelpButton } from "./HelpButton";

interface Props {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export function TopBar({ title, subtitle, children }: Props) {
  return (
    <header className="flex items-center justify-between gap-4 border-b border-line bg-surface px-8 py-4">
      <div className="min-w-0">
        <h1 className="truncate text-lg font-semibold text-ink">{title}</h1>
        {subtitle && (
          <p className="mt-0.5 truncate text-xs text-ink-muted">{subtitle}</p>
        )}
      </div>
      {/* Global search lives between page title and per-page actions —
          consistent slot on every page so executives know where to look. */}
      <div className="hidden md:flex flex-1 justify-center">
        <GlobalSearchTrigger />
      </div>
      {/* Per-page actions, then the global "+ New" — a project can be
          started from any page, Executive included. */}
      <div className="flex items-center gap-2 shrink-0">
        {children}
        <HelpButton />
        <NotificationBell />
        <NewEntityButton />
      </div>
    </header>
  );
}
